module.exports = __webpack_public_path__ + "img/kunozan.fd6f8661.jpg";